import { ApiUtility } from "./ApiUtility";

class VivekService {
  vaniRoute = "/api/vivekvanis?lang=";
  categoryRoute = "/api/settings/filters?lang=";
  languagebyid = "/api/languages/";
  vivekdetailRoute = "/api/VivekVanis/";
  faviroute = "/api/VivekVanis/";

  getFilters = (productFor: string) => {
    return ApiUtility.get(
      this.categoryRoute +
      localStorage.getItem("lan") +
      "&productFor=" +
      productFor
    );
  };

  getVanis = (
    start: number,
    length: number,
    categoryId: string,
    IsChildLiterature: boolean,
    sort: string,
    authorId: string,
    search: string,
    langId: string,
    isSpecial: boolean
  ) => {
    return ApiUtility.get(
      this.vaniRoute +
      localStorage.getItem("lan") +
      "&search=" +
      search +
      "&start=" +
      start +
      "&length=" +
      length +
      "&categoryId=" +
      categoryId +
      "&IsChildLiterature=" +
      IsChildLiterature +
      "&sort=" +
      sort +
      "&authorId=" +
      authorId +
      "&bookLangauge=" +
      langId +
      "&isSpecial=" +
      isSpecial
    );
  };


  // vivek vani details

  getVivekVaniDetail = (id: string) => {
    return ApiUtility.get(
      this.vivekdetailRoute +
      id +
      "?lang=" +
      localStorage.getItem("lan")
    );
  };

    getVivekVaniDetails = (id: string) => {
    const lang = localStorage.getItem("lan") || "hindi";
    return ApiUtility.get(`${this.vivekdetailRoute}${id}/SEO?lang=${lang}`);
  };
  
  getRelatedVivekVanis = (id: string, lang: string, authorId: string) => {
    if (id === "") {
      id = "null";
    }
    return ApiUtility.get(
      this.vivekdetailRoute +
      id +
      "/related?lang=" +
      localStorage.getItem("lan") +
      "&authorId=" +
      authorId
    );
  };

    GetLanguageDataById(id: string) {
    return ApiUtility.get(
      this.languagebyid + id + "?lang=" + localStorage.getItem("lan")
    );
  }

  addFavourite = (id: string) => ApiUtility.post(`/api/VivekVanis/${id}/favourite`, {});

  removeFavourite = (id: string) => ApiUtility.delete(`/api/VivekVanis/${id}/favourite`);

  // Fetch navigation details (TOC + lastPosition CFI)
  getNavigationDetails = (vivekVaniId: string) => {
    const payload = { vivekVaniId };
    return ApiUtility.post(`/api/VivekVanis/navigation-details`, payload);
  };

}
export default new VivekService();
